<script>import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const UpIcon = getIcon("UpIcon");
</script>

{#if typeof UpIcon === 'string'}
	<img src={UpIcon} alt={$t(Verbiage.up_icon_alt, 'alts')} />
{:else if typeof UpIcon === 'function'}
	<svelte:component this={UpIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
